<div class="table-header" [style.height.px]="headerHeight">
  @for (column of columns; track $index) {
    <ng-container *ngTemplateOutlet="cell"></ng-container>
  }
</div>

<div class="table-body">
  @for (row of rows; track $index) {
    <div class="table-row" [style.height.px]="rowHeight">
      @for (column of columns; track $index) {
        <ng-container *ngTemplateOutlet="cell"></ng-container>
      }
    </div>
  }
</div>

<ng-template #cell>
  <div class="skeleton-cell"></div>
</ng-template>
